export default {
    details: [],
    detailsCode: [],
    lots: [],
    products: [],
    loading: true
}
